import { useSelector } from 'react-redux';

export const useBalanceInformationBlock = () => {
    //@ts-ignore
    const { financial_info } = useSelector((store) => store.dashboardReducer);
    return { financial_info };
};
